const wcagLinks = document.querySelectorAll('a[href="#ustawienia-wcag"]');
if (wcagLinks?.length > 0) {
  wcagLinks.forEach((wcagLink) => {
    wcagLink.addEventListener('click', (e) => {
      e.preventDefault(); // prevent url change
      const revokeButton = document.querySelector('#Sea-Accessibility__ButtonWidget');
      if (revokeButton) {
        revokeButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    });
  });
}
